// extracted by mini-css-extract-plugin
export default {"container":"ApprovalEditor_container__Wd0ct"};